'use client';
import { GREY_400, GREY_800, GREY_1000, TEXT_FONT } from '@mnd-frontend/ui/shared/tokens';
import { scaledRemCalc } from '@mnd-frontend/utils';
import styled from 'styled-components';

export default styled.g<{ $noStroke?: boolean }>`
  path {
    stroke: ${props => (props.$noStroke ? 'none' : GREY_400)};
  }
  text {
    color: ${GREY_1000};
    font-family: ${TEXT_FONT};
    font-size: ${scaledRemCalc(12)};
    font-weight: normal;
    line-height: 1.25;
    fill: ${GREY_800};
  }
`;
